/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Steps/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Steps({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentComplete/Steps"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payersActivetabDataDownpaymentValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.data.downpayment',
})
let payersActivetabDataInstallmentValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.data.installment',
})
let aggregateData = fromAggregate.and(payersActivetabDataDownpaymentValueData, payersActivetabDataInstallmentValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}